import type { ReactNode } from 'react';
import { useGobalErrorHandler } from '../globle-error-handler.hook';

export const GlobalErrorHandler = (props: { children?: ReactNode }) => {
  useGobalErrorHandler();

  return props.children;
};
